import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const CTA_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/701db26e-2f85-4c67-a03d-0819f8e47bc6.jpg';
export function CTA() {
  return <section id="contact" className="relative w-full overflow-hidden" data-id="element-46" data-mp="1zg1754h4odfb">
      <div className="absolute inset-0" data-id="element-47" data-mp="1uirab3reszhg">
        <img src={CTA_IMG} alt="" aria-hidden="true" className="w-full h-full object-cover" data-id="element-48" data-mp="1ufn11rz37djx" />
        <div className="absolute inset-0 bg-navy/90" data-id="element-49" data-mp="11tts10n772op" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 py-28 md:py-36 text-center" data-id="element-50" data-mp="1ghyca91wfm9l">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-51" data-mp="1gk1dlp8i51tm">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-52" data-mp="j32nqdi2i2h6">
            <span className="h-px w-8 bg-gold" data-id="element-53" data-mp="j0q3tusr1i1h" />
            <span className="text-xs font-semibold tracking-widest uppercase text-gold" data-id="element-54" data-mp="33dbrdjexiytc">
              Let's Start the Conversation
            </span>
            <span className="h-px w-8 bg-gold" data-id="element-55" data-mp="3d46hiyvaqik2" />
          </div>

          <h2 className="font-serif text-4xl md:text-6xl leading-tight text-ivory" data-id="element-56" data-mp="3d4pzugouz8ym">
            Ready to unlock growth across Africa?
          </h2>
          <p className="mt-6 text-lg text-ivory/75 max-w-2xl mx-auto leading-relaxed" data-id="element-57" data-mp="2kfsj4i0apk7z">
            Whether you're entering a new market, launching a product, or building
            stronger customer relationships, Flicker Africa is ready to help.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center" data-id="element-58" data-mp="2tibjmvglzkr2">
            <a href="mailto:hello@flickerafrica.com" className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-gold text-navy font-semibold hover:bg-gold/90 transition-colors" data-id="element-59" data-mp="2ygv7j1erj6m2">
              Let's Start the Conversation
              <ArrowRightIcon size={18} className="transition-transform group-hover:translate-x-1" data-id="element-60" data-mp="29qwe8ltar9r7" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}